import { render, staticRenderFns } from "./ItemRangeSlider.vue?vue&type=template&id=367986d9&scoped=true&"
import script from "./ItemRangeSlider.vue?vue&type=script&lang=ts&"
export * from "./ItemRangeSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367986d9",
  null
  
)

export default component.exports